/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type GoalOverviewType = (typeof GoalOverviewType)[keyof typeof GoalOverviewType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoalOverviewType = {
  pension: "pension",
  financial_reserve: "financial_reserve",
  housing: "housing",
  vehicle: "vehicle",
  children: "children",
  other: "other",
} as const;
